<template>
    <div class="abnormal-abnormal">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="abnormalData" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="address" label="房源地址"></el-table-column>
                    <el-table-column align="center" prop="room" label="房间名称"></el-table-column>
                    <el-table-column align="center" prop="staydate" label="操作" min-width="50">
                        <template slot-scope="scope">
                            <el-button @click="toHouse(scope.$index, abnormalData)" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination-part">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="1"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="20"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "AbnormalAbnormal",
        data() {
            return{
                abnormalData:[],
                total:0,
                skip:0,
                limit:20,

            }
        },
        mounted(){
            this.abnormalroom();
        },
        methods:{
            //异常房间
            abnormalroom(){
                this.$http.get(`${store.state.url}zone/abnormalsuites/`+this.skip+`/`+this.limit+`?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let abnormalData = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    abnormalData[i] = {
                                        address: res.Data[i].Addr,
                                        room: res.Data[i].Room,
                                        suiteid: res.Data[i].Suiteid,
                                    }
                                }
                            }
                            this.abnormalData = abnormalData;
                            this.total = res.Expand;
                        } else {
                            this.abnormalData = [];
                            this.total = 0;
                            this.$message(res.Message);
                        }
                    })
            },

            //分页
            handleSizeChange(val) {
                this.limit=val;
                this.abnormalroom();
            },
            handleCurrentChange(val) {
                this.skip=(val-1)*this.limit;
                this.abnormalroom();
            },

            //导出1000条数据
            downloadData() {
                return new Promise((resolve, reject) => {
                    let abnormalData = [];
                    this.$http.get(`${store.state.url}zone/abnormalsuites/0/1000?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                if (res.Data != null) {
                                    for (let i in res.Data) {
                                        abnormalData[i] = {
                                            address: res.Data[i].Addr,
                                            room: res.Data[i].Room,
                                        }
                                    }
                                    resolve(abnormalData)
                                }
                            }
                        })
                })
            },
            //导出excel
            downloadMater() {
                this.downloadData().then((abnormalData) => {
                    const defaultCellStyle = {
                        font: {name: "Verdana", sz: 11, color: "FF00FF88"},
                        fill: {fgColor: {rgb: "FFFFAA00"}}
                    };
                    const wopts = {
                        bookType: 'xlsx',
                        bookSST: false,
                        type: 'binary',
                        defaultCellStyle: defaultCellStyle,
                        showGridLines: false
                    };
                    const wb = {SheetNames: ['Sheet1'], Sheets: {}, Props: {}};

                    let Data = [];
                    for (let i in abnormalData) {
                        Data[i] = {
                            房源地址: abnormalData[i].address,
                            房间名称: abnormalData[i].room,
                        };
                    }
                    let data = Data;
                    wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                    //创建二进制对象写入转换好的字节流
                    let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {type: "application/octet-stream"})
                    FileSaver.saveAs(tmpDown, "异常房间报表.xls");
                })
            },
            //字符串转字符流
            s2ab(s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },

            toHouse(index, row) {
                let sid = row[index].suiteid,
                    tableInfo = {};
                window.localStorage.sid = sid;
                tableInfo.table = 0;
                tableInfo.index = '3';
                store.commit('assignAbnormalPreTableTab', tableInfo);
                this.$router.push('./house');
            }
        }

    }
</script>

<style scoped>
    .button-group{
        margin-right:0.05rem;
    }

</style>